// extracted by mini-css-extract-plugin
export var chatHtmlText = "_tl-2";
export var chatLink = "_tl-0";
export var chatText = "_tl-1";